<script lang="ts">
    import {ASSET_URL} from "../config";
    import newUniqueId from 'locally-unique-id-generator'

    export let checked = false;
    export let label: string;
    export let description: string = null;
    /** The key to listen for */
    export let key: string = null;
    let id = newUniqueId();

    let isFocused = false;

    function onFocus() {
        isFocused = true;
    }

    function handleKey(e: KeyboardEvent) {
        return; //ignore!
        /*;
        if(!isFocused)
            return;
        console.log("handleKey");
        console.log(e.key);
        console.log("var key = " , key);
        if (key && e.key === key ) {
            checked = !checked;
        }
        */
    }

</script>

<svelte:window on:keypress={handleKey}/>

<label class:checked>
	<span class="start-item" style="background-image: {checked ? `url(${ASSET_URL}/assets/checkmark.svg)` : 'none'}">
	</span>
    <input type="checkbox" role="checkbox" aria-checked="false" bind:checked on:focus={onFocus} aria-labelledby="{id}">
    <span class="label-text">
		<span class="label-title" id="{id}">{label}</span>
		<span class="label-description">
			{#if !$$slots.description}{description}{/if}
            <slot name="description"></slot>
		</span>
	</span>
</label>

<style lang="scss">
  $start-item-offset: #{6px + 1px}; // 1px because of parent border
  label {
    border: 1px solid black;
    border-radius: 5px;

    display: flex;
    cursor: pointer;
    //margin-left: $start-item-offset;

    .start-item {
      border: 1px solid #000000;
      border-radius: 5px;
      width: 30px;
      height: 30px;

      margin-top: 10px;
      //padding: #{30px / 2 - 1px}; // 1px border //better: padding: 30px / 2 - 1px;
      padding: 14px;
      background-color: white;
      transform: translateX(-$start-item-offset);
    }

    &.checked {
      .start-item {
        border: 3px solid #DE1125;
        //background-image: url({ASSET_URL}/assets/checkmark.svg);
        background-repeat: no-repeat;
        //background-size: contain;
        background-position: center;

        //padding: #{30px / 2 - 3px}; // 3px border
		  padding: 12px;
      }
    }

    &:focus-within {
      box-shadow: var(--btn-focus-box-shadow);
    }

    .label-text {
      font-family: 'Open Sans', sans-serif;
      color: black;
      letter-spacing: 0;
      text-align: left;

      padding: 15px 20px 40px 20px;

      & > span {
        display: block;
        color: black;
      }

      .label-title {
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;

        margin-bottom: 25px;
      }

      .label-description {
        font-style: normal;
        font-weight: 300;
        font-size: 1rem;
        line-height: 1.2rem;
      }
    }
  }

  input[type="checkbox"] {
    all: unset; /* remove default styles */
  }
</style>
